import invites from './list/sagas'
import inviteDetails from './details/sagas'
import createInvite from './create/sagas'
import destroyInvite from './destroy/sagas'
import updateInvite from './update/sagas'

export default [invites, inviteDetails, createInvite, destroyInvite, updateInvite]
